module.exports = __webpack_public_path__ + "static/img/gold_fish_bg.2e53774.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/piece/gold_fish_bg.png
// module id = Im+N
// module chunks = 0